import { render, staticRenderFns } from "./ResultMessage.vue?vue&type=template&id=98ee8ab0&scoped=true"
import script from "./ResultMessage.vue?vue&type=script&lang=js"
export * from "./ResultMessage.vue?vue&type=script&lang=js"
import style0 from "./ResultMessage.vue?vue&type=style&index=0&id=98ee8ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ee8ab0",
  null
  
)

export default component.exports